import { render } from "./NavBar.vue?vue&type=template&id=6db0d827&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=6db0d827&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard.lims.ninja/dashboard.lims.ninja/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db0d827"]])

export default __exports__